module.exports = __webpack_public_path__ + "img/title2-ja.b6d47655.png";